import Vue from 'vue';

const state = {
    data: [],
};

const getters = {
    getEntries(state) {
        return state.data;
    },
    getSelectableEntries(state) {
        const listItem = [];

        if (state.data.length <= 0) {
            return [];
        }

        Array.from(state.data).forEach((item) => {
            listItem.push({value: item.id, label: item.title});
        });
        return listItem;
    },
    getTasks(state) {
        return state.data.tasks || [];
    }
};

const mutations = {
    SET_DATA(state, stages) {
        state.data = stages;
    },
};

const actions = {

    setEntry: function ({dispatch, commit}) {
        commit('SET_DATA', {
            id: '',
            title: '',
            images: [],
            documents: [],
            video: '',
        });
    },

    loadEntries: function ({dispatch, commit}, postID = 0) {

        const ID = postID || '';
        const token = this.state.login.user.token;

        Vue.prototype.$Api().defaults.headers.common["Authorization"] = `Bearer ${token}`;

        return new Promise((resolve, reject) => {

            Vue.prototype.$Api().get("/wp/v2/house-blocks/" + ID)
                .then(({data}) => {

                    let blockRows = [];

                    if (data instanceof Array) {

                        data.forEach((lot) => {

                            blockRows.push({
                                id: lot.id,
                                title: lot.title.rendered,
                                images: lot.acf.images.length,
                                video: lot.acf.video,
                            })

                        });

                    } else {

                        blockRows = {
                            id: data.id,
                            title: data.title.rendered,
                            images: data.acf.images || [],
                            documents: data.acf.documents || [],
                            video: data.acf.video,
                            tasks: data.tasks
                        }

                    }

                    commit('SET_DATA', blockRows);
                    resolve();

                })
                .catch((response) => {
                    const code = response.response.data.code;
                    const httpCode = response.response.data.data.status;
                    console.log(httpCode, code);
                    reject();
                });

        });

    },

    updateEntry({dispatch, commit, state}) {

        const stageData = state.data;
        const ID = stageData.id || '';

        const images = [];

        if (Array.isArray(stageData.images) && stageData.images.length > 0) {
            stageData.images.forEach((item) => {
                images.push(item.ID);
            });
        }

        const documents = [];

        if (Array.isArray(stageData.documents) && stageData.documents.length > 0) {
            stageData.documents.forEach((item) => {
                documents.push({file: item.file.ID, title: item.title})
            });
        }

        const params = {
            title: stageData.title,
            fields: {
                video: stageData.video,
                images: images,
                documents: documents
            },
            status: 'publish'
        };

        const token = this.state.login.user.token;

        Vue.prototype.$Api().defaults.headers.common["Authorization"] = `Bearer ${token}`;

        return new Promise((resolve, reject) => {

            Vue.prototype.$Api().post("/wp/v2/house-blocks/" + ID, params)
                .then((response) => {
                    resolve();
                })
                .catch((response) => {
                    const code = response.response.data.code;
                    const httpCode = response.response.data.data.status;
                    console.log(httpCode, code);
                    reject();
                });

        });

    }

};

export const stages = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};